import React from 'react';

const BackgroundAnimation = () => {
  return (
    <div className="background-animation">
      <div className="bg-grid" />
      <div className="bg-glow bg-glow-1" />
      <div className="bg-glow bg-glow-2" />
      <img src="soc.jpg" alt="" className="bg-circuit" />
    </div>
  );
};

export default BackgroundAnimation;
